import { Component, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { AppDialog } from '../../../shared/ui/dialog/app-dialog';

/**
 * Dialogue "Motif du rejet" d'une publicité — extrait du bloc inline précédemment
 * dans ad-list.html. Contenu propre au module ads (texte d'indication spécifique
 * aux publicités) ; s'appuie sur la coquille générique `app-dialog`.
 *
 * Usage :
 *   <app-reject-ad-dialog [(visible)]="rejectDialogVisible" [(text)]="rejectText"
 *                          [loading]="processing() === rejectTarget()?.id"
 *                          (confirm)="confirmReject()" (cancel)="cancelReject()" />
 */
@Component({
  selector: 'app-reject-ad-dialog',
  standalone: true,
  imports: [FormsModule, ButtonModule, TextareaModule, AppDialog],
  templateUrl: './reject-ad-dialog.html',
  styleUrl: './reject-ad-dialog.scss'
})
export class RejectAdDialogComponent {
  visible = model<boolean>(false);
  text = model<string>('');

  loading = input<boolean>(false);
  placeholder = input<string>('ex : visuel non conforme, lien invalide…');

  confirm = output<void>();
  cancel = output<void>();

  confirmDisabled = computed(() => !this.text().trim() || this.loading());
}
